import { IDonationRate } from "@/props/IDonation";
import { useTranslation } from "next-i18next";
import Image from "next/image";

// 项目亮点 / 项目执行计划
const EventHighlights = ({ isIB, tradingRate }: { isIB?: boolean; tradingRate: IDonationRate }) => {
  const { t } = useTranslation();
  const highlights = [
    {
      imageUrl: "/images/csr/highlight_2.webp",
      width: isIB ? 416 : 604,
      height: isIB ? 320 : 464,
      title: t(`csr.highlights_tit2`),
      desc: t(`csr.highlights_desc2`),
    },
  ];

  if (isIB) {
    highlights.push({
      imageUrl: "/images/csr/highlight_3.webp",
      width: 416,
      height: 320,
      title: t(`csr.highlights_tit3`),
      desc: t(`csr.highlights_desc3`),
    });
    highlights.push({
      imageUrl: "/images/csr/highlight_1.webp",
      width: 416,
      height: 320,
      title: t(`csr.highlights_tit1`),
      desc: t(`csr.highlights_desc1`),
    });
  }

  return (
    <div className="relative">
      {/* Background image using next/image */}
      <Image
        src="/images/csr/highlight_bg.webp"
        alt="Event highlights background"
        fill
        className="-z-10 object-cover object-center"
        quality={100}
      />
      <div className="m-auto max-w-[1440px] py-[70px]">
        <h1 className="mb-[68px] h-[60px] text-center text-5xl font-semibold text-stone-800">
          {t("csr.event")}
          <span className="ml-1 inline-block bg-yellow-600 p-2">{t("csr.execution_plan")}</span>
        </h1>
        <div className="flex justify-center">
          <div className={`flex flex-row gap-8 ${isIB ? "w-full" : "w-[1168px]"}`}>
            {highlights.map((highlight, index) => (
              <div
                key={index}
                className={`flex flex-1 rounded-[32px] bg-white p-6 text-left shadow-sm ${
                  isIB ? "flex-col gap-4" : "w-full flex-row items-center"
                }`}
              >
                <div className="relative shrink-0" style={{ width: highlight.width, height: highlight.height }}>
                  <Image
                    src={highlight.imageUrl}
                    fill
                    className="rounded-md object-cover"
                    alt={`highlight_${index + 1}`}
                  />
                </div>
                <div className={`${isIB ? "mt-12" : "ml-12"}`}>
                  <p className={`mb-4 font-semibold text-stone-800 ${isIB ? "text-2xl" : "text-3xl"}`}>
                    {highlight.title}
                  </p>
                  <p className="text-xl text-[#4c4c4c]">{highlight.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EventHighlights;
